import SetPlayerCreditFantacy from './SetPlayerCreditFantacy';

export default SetPlayerCreditFantacy;